<template>
  <div class="lxn-w100 lxn-h100">
    <div class="SingleSwitchWidget-wrapper-switch lxn-margin-auto">
      <SingleSwitch @switchClicked="toggleOutput()" :state="currentSwitchState" :bgColorOn="widgetColor" bgColorOff="#ACB8BF" bgColorPending="#CCCCCC" handleColorOn="#FFFFFF" handleColorOff="#FFFFFF" :disabled="isHubOffline" />
    </div>
    <div class="SingleSwitchWidget-wrapper-text lxn-w100 lxn-text-center lxn-text" :style="currentSwitchStateColor" :class="[$store.getters.language.font, $store.getters.language.directionClass]">
      {{currentSwitchStateText}}
    </div>
  </div>
</template>

<script>

import SingleSwitch from '@/components/SingleSwitch.vue'
import * as CONFIGS from '@/statics/configs.js'
import Logger from '@/statics/logger.js'
import Messaging from '@/statics/messaging.js'

export default {
  name: 'S1TouchWidget',
  props: {
    index: Number
  },
  components: {
    SingleSwitch,
  },
  data: function () {
    return {
      switchLocked: false,
      switchStatus: 0,
    }
  },
  // watch: {
  //   switchState: function (newVal) {
  //     this.currentSwitchState = (newVal == 1) ? 'on' : 'off';
  //   },
  // },
  // mounted: function () {
  //   this.currentSwitchState = this.switchState == 1 ? 'on' : 'off';
  // },
  computed: {
    widget: function () {
      return this.$store.state.widgets[this.index];
    },
    widgetColor: function () {
      return this.$store.state.themeMainColors[this.widget.color];
    },
    node: function () {
      return this.$store.getters.getNodeByUUID(this.widget.nodeUUIDs[0]);
    },
    hub: function () {
      return this.$store.getters.getHubByUUID(this.widget.hubUUID);
    },
    output: function () {
      return this.node.outputs[this.widget.settings.outputIndex];
    },
    switchState: function () {
      var switchState = this.$store.getters.getParameterValue(this.node.index, this.output.parameterId);
      if(switchState == undefined){
        return 0;
      }else{
        return switchState;
      }
    },
    currentSwitchState: function () {
      return (this.switchState == 1) ? 'on' : 'off';
    },
    isNodeOffline: function () {
      if(this.node.connectionStatus == 1){
        return false;
      }else{
        return true;
      }
    },
    isHubOffline: function () {
      if(this.hub.connectionStatus.local == 2 || this.hub.connectionStatus.online == 2){
        return false;
      }else{
        return true;
      }
    },
    currentSwitchStateText: function () {
      if(this.isNodeOffline){
        return this.$store.getters.language.texts.RelaySSR2ASettings_switchState_Unknown;
      }else{
        if(this.currentSwitchState == 'on'){
          return this.$store.getters.language.texts.RelaySSR2ASettings_switchState_On;
        }else if(this.currentSwitchState == 'off'){
          return this.$store.getters.language.texts.RelaySSR2ASettings_switchState_Off;
        }else{
          return 'undefined'
        }
      }
    },
    currentSwitchStateColor: function () {
      if(this.isNodeOffline){
        return 'color: #FF946B';
      }else{
        if(this.currentSwitchState == 'on'){
          return 'color: ' + this.widgetColor;
        }else if(this.currentSwitchState == 'off'){
          return 'color: #52626C';
        }else{
          return 'color: #ffffff';
        }
      }
    },
  },
  methods: {
    toggleOutput: function () {
      if(!this.switchLocked){
        this.$store.commit('setHubStatus', {
          hubIndex: this.hub.index,
          stateUpdateEnabled: false,
        });
        this.switchLocked = true;
        this.$store.commit('setAppBusy', true);
        console.log(this.normallyClosed);
        if(this.currentSwitchState == 'on'){
          var valueOfChange = 0;
        }else{
          valueOfChange = 1;
        }
        this.$store.commit('setParameterValue', {nodeIndex: this.node.index, parameterId: this.output.parameterId, parameterValue: valueOfChange});
        var messagingHook = new Messaging(new Logger(false));
        messagingHook.init({
          psk: this.hub.psk,
          destinationUUID: this.hub.uuid,
          sourceUUID: this.$store.state.user.uuid
        });
        this.$store.dispatch('setNodesParameters', {
          messagingHook: messagingHook,
          hubUUID: this.hub.uuid,
          nodeUUID: this.node.uuid,
          bodyContent: {
            nodeActions: [
              {
                nodeUUID: this.node.uuid,
                actions: [
                  {
                    parameterId: this.output.parameterId,
                    valueOfChange: valueOfChange,
                    typeOfAction: CONFIGS.ACTION_TYPE_SET,
                    timeDelay: 0
                  }
                ]
              },
            ]
          }
        })
        .then( () => {
          this.switchLocked = false;
          this.$store.commit('setAppBusy', false);
        })
        .catch( response => {
          this.switchLocked = false;
          this.$store.commit('setAppBusy', false);
          if(response.rejectCode == 2){
            this.$store.commit('setHubStatus', {
              hubIndex: response.hubIndex,
              connectionStatus: {
                local: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
                online: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
              },
            });
          }
        })
        .finally( () => {
          this.$store.commit('setHubStatus', {
            hubIndex: this.hub.index,
            stateUpdateEnabled: true,
          });
        });
      }
    },
  },
}
</script>

<style>
  .SingleSwitchWidget-wrapper-switch {
    height: 40px;
    width: 80px;
    padding-top: 10px;
  }
  .SingleSwitchWidget-wrapper-text {
    height: 30px;
    line-height: 30px;
  }
</style>
